module.exports = __webpack_public_path__ + "static/img/Air pollution-01-01.37bd0531.jpg";